import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { NotifierService } from "angular-notifier";
import { FormField } from "src/app/interfaces/form-field.model";
import {
  faPencil,
  faEraser,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { ServiceEnquiryService } from "src/app/services/autopac/service-enquiry.service";

@Component({
  selector: "app-service-enquiry",
  templateUrl: "./service-enquiry.component.html",
  styleUrls: ["./service-enquiry.component.css"],
})
export class ServiceEnquiryComponent implements OnInit, OnDestroy {
  faPencil = faPencil;
  faEraser = faEraser;
  faPlus = faPlus;
  searchVehicle: FormField[] = [];
  locationFields: FormField[] = [];
  vehicleDetail: any = null;
  userId = "";
  loading = false;
  saving = false;
  message = "";
  selectedTab: "main" | "location" = "main";
  private searchRequest?: Subscription;
  private updateRequest?: Subscription;
  accessoriesContractHeaders = [
    { id: "IsCompleted", title: "COMPLETED?", type: "checkbox" },
    { id: "Description", title: "ITEM", type: "data" },
  ];
  installedAccessoriesHeaders = [
    { id: "item", title: "ITEM", type: "data" },
  ];
  locationListHeaders = [
    { id: "Loc", title: "LOCATION", type: "data" },
    { id: "LocDate", title: "DATE", type: "data" },
    { id: "Remarks", title: "REMARKS", type: "data" },
    { id: "action", title: "ACTION", type: "trash" },
  ];
  accessoriesContractEntries: any[] = [];
  installedAccessoriesEntries: { item: string }[] = [];
  locationListEntries: any[] = [];
  private fieldMap: Record<string, string> = {
    vinNumber: "CaseNumber",
    engineNumber: "EngineNumber",
    registrationDate: "RegistrationDate",
    registrationNumber: "RegistrationNo",
    chasisNumber: "ChasisNumber",
    jobStatus: "JobStatus",
    model: "Model",
    colour: "Colour",
    readyDate: "ReadyDate",
    contractNumber: "ContactNumber",
    carType: "CarType",
    qcStatus: "QcStatus",
    salesConsultant: "SalesConsultant",
    dutyStatus: "DutyStatus",
    qcBy: "QcBy",
    dutyStatusDate: "DutyStatusDate",
    remark: "Remark",
  };
  constructor(
    private serviceEnquiryService: ServiceEnquiryService,
    private notifier: NotifierService,
  ) {}

  changeTab(tab: "main" | "location"): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {
    this.searchVehicle = [
      {
        type: "search",
        id: "vinNumber",
        label: "VIN Number",
        searchEvent: true,
        searchType: "CaseNumber",
      },
      {
        type: "text",
        id: "engineNumber",
        label: "Engine Number",
        lock: true,
      },
      {
        type: "date",
        id: "registrationDate",
        label: "Registration Date",
        lock: true,
      },
      {
        type: "search",
        id: "registrationNumber",
        label: "Registration Number",
        searchEvent: true,
        searchType: "RegNumber",
      },
      {
        type: "search",
        id: "chasisNumber",
        label: "Chassis Number",
        searchEvent: true,
        searchType: "ChasisNumber",
      },
      {
        type: "select",
        id: "jobStatus",
        label: "Job Status",
        options: [
          { display: "Completed", value: "Completed" },
          { display: "Completed (P)", value: "Completed (P)" },
          { display: "Completed (A)", value: "Completed (A)" },
          { display: "Completed (P&A)", value: "Completed (P&A)" },
        ],
      },
      { type: "text", id: "model", label: "Model", lock: true },
      { type: "text", id: "colour", label: "Colour", lock: true },
      { type: "date", id: "readyDate", label: "Ready Date" },
      {
        type: "text",
        id: "contractNumber",
        label: "Contract Number",
        lock: true,
      },
      { type: "text", id: "carType", label: "Car Type", lock: true },
      {
        type: "select",
        id: "qcStatus",
        label: "QC Status",
        options: [
          { display: "Not Completed", value: "Not Completed" },
          { display: "Completed", value: "Completed" },
        ],
      },
      {
        type: "text",
        id: "salesConsultant",
        label: "Sales Consultant",
        lock: true,
      },
      {
        type: "text",
        id: "dutyStatus",
        label: "Duty Status",
        lock: true,
      },
      { type: "text", id: "qcBy", label: "QC By", lock: true },
      {
        type: "date",
        id: "dutyStatusDate",
        label: "Duty Status Date",
        lock: true,
      },
      { type: "textarea", id: "remark", label: "Remark" },
    ];

    this.locationFields = [
      { type: "text", id: "location", label: "Location" },
      { type: "date", id: "date", label: "Date" },
      { type: "text", id: "remark", label: "Remark" },
    ];
  }

  onVehicleChange(event: {
    fields: FormField[];
    updatedValue: number;
  }): void {
    this.searchVehicle = event.fields;
    const field = event.fields[event.updatedValue];
    if (!field) return;
    if (field.searchType) {
      this.searchRequest?.unsubscribe();
      this.loading = false;
      this.vehicleDetail = null;
      this.userId = "";
      this.accessoriesContractEntries = [];
      this.installedAccessoriesEntries = [];
      this.locationListEntries = [];
      this.locationFields = this.locationFields.map((f) => ({
        ...f,
        value: "",
      }));
      this.searchVehicle = this.searchVehicle.map((f) => ({
        ...f,
        value: f.id === field.id ? field.value : "",
      }));
      this.message = "";
      return;
    }
    if (!this.vehicleDetail) return;
    // Preserve untouched API values; only serialize fields the user changed.
    this.vehicleDetail[this.fieldMap[field.id]] =
      field.type === "date"
        ? this.toApiDate(field.value)
        : field.value;
    if (field.id === "qcStatus") {
      this.vehicleDetail.QcBy =
        field.value === "Completed" ? this.userId : "";
      this.searchVehicle = this.searchVehicle.map((f) =>
        f.id === "qcBy"
          ? { ...f, value: this.vehicleDetail.QcBy }
          : f,
      );
    }
  }

  handleSearch(event: { fieldId: string }): void {
    if (this.saving) return;
    const field = this.searchVehicle.find(
      (f) => f.id === event.fieldId,
    );
    const text = String(field?.value ?? "").trim();
    if (!field?.searchType || !text) {
      this.notifier.notify(
        "error",
        "Please enter a value to search.",
      );
      return;
    }
    const searchType = field.searchType;
    this.clear();
    this.searchVehicle.find((f) => f.id === event.fieldId)!.value =
      text;
    this.loading = true;
    this.searchRequest = this.serviceEnquiryService
      .getVehicleDetails(searchType, text)
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response.code !== 0 || !response.body?.VehicleDetail) {
            this.message =
              response.message ||
              "Unable to retrieve vehicle details.";
            this.notifier.notify("error", this.message);
            return;
          }
          const data = response.body;
          this.userId = data.UserId;
          this.vehicleDetail = {
            ...data.VehicleDetail,
            UserId: data.UserId,
          };
          this.searchVehicle = this.searchVehicle.map((f) => {
            const value = this.vehicleDetail[this.fieldMap[f.id]];
            return {
              ...f,
              value:
                f.type === "date" ? this.toInputDate(value) : value,
            };
          });
          this.accessoriesContractEntries = (
            data.AccessoriesOnContact || []
          ).map((item: any) => ({ ...item }));
          this.installedAccessoriesEntries = (
            data.InstalledAccessory || []
          ).map((item: string) => ({ item }));
          this.locationListEntries = (
            data.AccessoryLocation || []
          ).map((item: any) => ({ ...item }));
        },
        error: () => {
          this.loading = false;
          this.message = "Unable to retrieve vehicle details.";
          this.notifier.notify("error", this.message);
        },
      });
  }

  private toInputDate(value: string | null): string {
    if (!value) return "";
    const [day, month, year] = value.split("/");
    return year + "-" + month + "-" + day;
  }

  private toApiDate(value: string | null | undefined): string {
    if (!value) return "";
    const [year, month, day] = value.split("-");
    return day + "/" + month + "/" + year;
  }

  addLocation(): void {
    if (!this.vehicleDetail || this.saving) return;
    const get = (id: string) =>
      this.locationFields.find((f) => f.id === id)?.value;
    const location = get("location");
    if (!String(location ?? "").trim()) {
      this.notifier.notify("error", "Please enter a location.");
      return;
    }
    const rawDate = get("date");
    let date = rawDate ? this.toApiDate(rawDate) : (rawDate ?? "");
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    const today =
      pad(now.getDate()) +
      "/" +
      pad(now.getMonth() + 1) +
      "/" +
      now.getFullYear();
    // V1 includes the current time only for a location dated today.
    if (date === today) {
      date +=
        " " +
        pad(now.getHours() % 12 || 12) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds()) +
        (now.getHours() < 12 ? " AM" : " PM");
    }
    this.locationListEntries = [
      ...this.locationListEntries,
      { Loc: location, Remarks: get("remark"), LocDate: date },
    ];
    this.locationFields = this.locationFields.map((f) => ({
      ...f,
      value: "",
    }));
  }

  onRemoveEntry(entry: any): void {
    if (this.saving) return;
    this.locationListEntries = this.locationListEntries.filter(
      (item) => item !== entry,
    );
  }

  clear(): void {
    if (this.saving) return;
    this.searchRequest?.unsubscribe();
    this.loading = false;
    this.message = "";
    this.vehicleDetail = null;
    this.userId = "";
    this.ngOnInit();
    this.accessoriesContractEntries = [];
    this.installedAccessoriesEntries = [];
    this.locationListEntries = [];
  }

  update(): void {
    if (this.saving || this.loading) return;
    if (!this.vehicleDetail?.CaseNumber) {
      this.notifier.notify(
        "error",
        "Please search for a vehicle before updating.",
      );
      return;
    }
    const payload = {
      model: {
        VehicleDetail: { ...this.vehicleDetail },
        AccessoriesOnContact: this.accessoriesContractEntries.map(
          (item) => ({ ...item }),
        ),
        InstalledAccessory: this.installedAccessoriesEntries.map(
          (entry) => entry.item,
        ),
        AccessoryLocation: this.locationListEntries.map((item) => ({
          ...item,
        })),
        UserId: "",
        Date: "",
      },
    };
    this.saving = true;
    this.updateRequest = this.serviceEnquiryService
      .updateServiceEnquiry(payload)
      .subscribe({
        next: (response) => {
          this.saving = false;
          if (response.code !== 0) {
            this.notifier.notify(
              "error",
              response.message || "Unable to update service enquiry.",
            );
            return;
          }
          this.notifier.notify(
            "success",
            "Record updated successfully!",
          );
          this.clear();
        },
        error: () => {
          this.saving = false;
          this.notifier.notify(
            "error",
            "Unable to update service enquiry.",
          );
        },
      });
  }

  ngOnDestroy(): void {
    this.searchRequest?.unsubscribe();
    this.updateRequest?.unsubscribe();
  }
}
